import { SLACK_SETTINGS } from '../constant/actionTypes';

const getSlackSettings = (state, action) => {
  switch (action.type) {
    case SLACK_SETTINGS.GET.INITIATE:
      return { isFetching: true, data: action.payload };
    case SLACK_SETTINGS.GET.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SLACK_SETTINGS.GET.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? {} : state;
  }
};

export default getSlackSettings;
